// URL DA INDEX.BLADE
export let URLASSOLUTO;

export default (initialData) => {
	URLASSOLUTO = initialData['URLASSOLUTOVARIABLE'];
	return URLASSOLUTO;
};
